import { useFormikContext } from 'formik';

export const useShouldDisableFormikField = (overrideDisabled) => {
  const { isSubmitting } = useFormikContext();
  return (condition = false) => (overrideDisabled ? isSubmitting : condition || isSubmitting);
};
